// extracted by mini-css-extract-plugin
export var text = "_36-0";